import React, { Fragment, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import G from '../util/globalFunction'

export const usePopup = (initTitle, handleValue) => {
    const [openInfo, setOpenInfo] = useState({ open: false })
    const [title, setTitle] = useState(initTitle)

    const handleClose = () => {
        setOpen(false)
    }
    const handleAccept = async value => {
        handleValue && (await handleValue(value))
        handleClose()
    }
    const setOpen = (open, param) => setOpenInfo({ open, param })

    const { open, param } = openInfo
    return { open, param, setOpen, title, setTitle, handleAccept, handleClose }
}

export default props => {
    const [storedValue, setStoredValue] = useState(null)
    const firstRef = useRef(null)
    const firstRefdiv = useRef(null)
    const { title, buttons, handleClose, children, zIndex, popupType, width, height } = props

    /*useEffect(() => {
        
        //firstRef.current && firstRef.current.focus()
        firstRef.current.focus()  
    }, [])*/
    
    const displayButton = buttons
        || [
            {
                title: G.t('trem.lang.home.0146'), /* 닫기 */
                handler: handleClose
            }
        ]

    const childWrap = !children
        ? null
        : Array.isArray(children)
            ? children.map((child, index) =>
                React.cloneElement(child, {
                    key: index,
                    modalprops: { ...props, storedValue, setStoredValue },
                })
            )
            : React.cloneElement(children, { modalprops: { ...props, storedValue, setStoredValue } })
     
    return (
        <Fragment>
            <div
                className="bg-black bg-opacity-50 fixed top-0 left-0 w-screen h-screen flex items-center justify-center"
                style={{ zIndex: zIndex || 7000 }}
            >
                <div className="popup_wrap">
                    <div
                        role={popupType ==='alert'? "alertdialog":""} 
                        aria-labelledby="popup_tt"
                        className={
                            popupType === 'alert' || popupType === 'confirm'
                                ? 'popup_box'
                                : `popup_box_w${width ? width : 800} popup_box_h${height ? height : 600
                                } popup_box2`
                                
                        }
                        
                    >

                        
                        <div className="popup_tt" id="popup_tt">
                            <h3>
                                {G.t(title)}
                            </h3>
                            <a onClick={handleClose} className="pop_close">
                                {G.t('trem.lang.home.0146')}
                                {/* 닫기 */}
                            </a>
                        </div>
                        <div className="popup_con">{childWrap}</div>
                        <div className="popup_btn">
                            {displayButton.map((obj, index) => (
                                <button
                                    key={index}
                                    ref={!index ? firstRef : null}
                                    className={obj.className}
                                    onClick={() => obj.handler(storedValue)}
                                    alt={obj.title}
                                >
                                    {obj.title}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}